<template>
    <nav class="p-grid p-fluid p-justify-center">
        <header class="p-col-12" style="text-align: center">
            <h1 :style="customStyle">
                <slot>m-navigator</slot>
            </h1>
        </header>
    </nav>
</template>

<script>
export default {
    props: {
        customStyle: {
            type: Object,
            default: function () {
                return { fontSize: '2.5rem' }
            }
        }
    }
}
</script>